import { Stack, Typography } from "@mui/material";
import CustomMenu from "components/atoms/CustomMenu";
import React from "react";

function CaptionAndFilter({ filter, handleDropdown, icon, title, subTitle }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent={"space-between"}
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={1}
    >
      <Stack spacing={1} direction={"row"}>
        {icon}

        <hgroup>
          <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography
            sx={{ opacity: "0.7", fontSize: "12px", fontWeight: 600 }}
          >
            {subTitle}
          </Typography>
        </hgroup>
      </Stack>
      <CustomMenu
        caption={filter.name}
        onClickItem={handleDropdown}
        popperSx={{ width: "10%" }}
        items={[
          { name: "Today", value: "Today" },
          { name: "This week", value: "ThisWeek" },
          { name: "This Month", value: "ThisMonth" },
          { name: "This Year", value: "ThisYear" },
        ]}
      />
    </Stack>
  );
}

export default CaptionAndFilter;
